import { Checkbox, Text } from "@seneca/senekit";
import { Expose } from "@seneca/small-utils-library";

export default function MarketingEmailsCheckbox(
  props: Expose<Parameters<typeof Checkbox>[0]>
) {
  return (
    <Checkbox {...props}>
      <Text size="small" tone="neutral">
        I want to hear how to boost my child's confidence & grades via extra
        support from Seneca & our partners
      </Text>
    </Checkbox>
  );
}
